export default __webpack_public_path__ + "static/media/HASSSAN.ab93b2b8.jpg";